// extracted by mini-css-extract-plugin
export var container = "_c7-0";
export var content = "_c7-3";
export var customerTitle = "_c7-4";
export var empty = "_c7-5";
export var gray = "_c7-6";
export var header = "_c7-7";
export var info = "_c7-8";
export var loading = "_c7-2";
export var loadingCard = "_c7-9";
export var oneLine = "_c7-a";
export var personName = "_c7-e";
export var pillContainer = "_c7-b";
export var selected = "_c7-1";
export var text = "_c7-c";
export var twoLines = "_c7-d";
export var unread = "_c7-f";
export var unreadIndicator = "_c7-g";